import React, { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { toast } from 'sonner';
import { X, Loader2, Plus, Trash2 } from 'lucide-react';
import { DatePicker, TimePicker } from '../DateTimePicker';
import { getWorkersDropdown, getAllUsersDropdown } from '../../services/api';

export function AddAssigneeModal({ isOpen, onClose, onSubmit, loading }) {
  const [formData, setFormData] = useState({ assignee_id: '', start_date: '', end_date: '', start_time: '', end_time: '' });
  const { data: users } = useQuery({ queryKey: ['usersDropdown'], queryFn: () => getAllUsersDropdown().then(r => r.data), enabled: isOpen });
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-testid="add-assignee-modal">
      <div className="bg-white rounded-lg w-full max-w-md">
        <div className="p-4 border-b"><h2 className="font-semibold">Add Assignee</h2></div>
        <form onSubmit={e => { e.preventDefault(); if (!formData.assignee_id) { toast.error('Please select an assignee'); return; } onSubmit(formData); }} className="p-6 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div><label className="block text-sm text-slate-500 mb-1">Start Date</label><DatePicker value={formData.start_date} onChange={v => setFormData({...formData, start_date: v})} /></div>
            <div><label className="block text-sm text-slate-500 mb-1">End Date</label><DatePicker value={formData.end_date} onChange={v => setFormData({...formData, end_date: v})} /></div>
          </div>
          <div><label className="block text-sm text-slate-500 mb-1">Assignee</label>
            <select value={formData.assignee_id} onChange={e => setFormData({...formData, assignee_id: e.target.value})} className="w-full px-3 py-2 border rounded text-sm" data-testid="add-assignee-select">
              <option value="">Select Assignee</option>
              {users?.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
            </select>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div><label className="block text-sm text-slate-500 mb-1">Start Time</label><TimePicker value={formData.start_time} onChange={v => setFormData({...formData, start_time: v})} /></div>
            <div><label className="block text-sm text-slate-500 mb-1">End Time</label><TimePicker value={formData.end_time} onChange={v => setFormData({...formData, end_time: v})} /></div>
          </div>
          <div className="flex justify-end gap-3 pt-4 border-t">
            <button type="button" onClick={onClose} className="px-4 py-2 text-sm border rounded">Cancel</button>
            <button type="submit" disabled={loading} className="px-4 py-2 text-sm bg-blue-500 text-white rounded flex items-center gap-2" data-testid="add-assignee-submit">{loading && <Loader2 size={16} className="animate-spin" />}Add</button>
          </div>
        </form>
      </div>
    </div>
  );
}

// === RESCHEDULE ASSIGNEE MODAL ===


export function RescheduleModal({ isOpen, onClose, onSubmit, loading, assignee }) {
  const [formData, setFormData] = useState({ date: '', date_end: '', time_start: '', time_end: '' });
  useEffect(() => {
    if (isOpen && assignee) {
      setFormData({
        date: assignee.date || '',
        date_end: assignee.date_end || '',
        time_start: assignee.time_start || '08:00',
        time_end: assignee.time_end || '17:00',
      });
    }
  }, [isOpen, assignee]);
  if (!isOpen || !assignee) return null;
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-testid="reschedule-modal">
      <div className="bg-white rounded-lg w-full max-w-md">
        <div className="p-4 border-b"><h2 className="font-semibold">Re-Schedule — {assignee.name}</h2></div>
        <form onSubmit={e => { e.preventDefault(); onSubmit(assignee.schedule_id, formData); }} className="p-6 space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div><label className="block text-sm text-slate-500 mb-1">Start Date</label><DatePicker value={formData.date} onChange={v => setFormData({...formData, date: v})} testId="reschedule-start-date" /></div>
            <div><label className="block text-sm text-slate-500 mb-1">End Date</label><DatePicker value={formData.date_end} onChange={v => setFormData({...formData, date_end: v})} testId="reschedule-end-date" /></div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div><label className="block text-sm text-slate-500 mb-1">Start Time</label><TimePicker value={formData.time_start} onChange={v => setFormData({...formData, time_start: v})} testId="reschedule-start-time" /></div>
            <div><label className="block text-sm text-slate-500 mb-1">End Time</label><TimePicker value={formData.time_end} onChange={v => setFormData({...formData, time_end: v})} testId="reschedule-end-time" /></div>
          </div>
          <div className="flex justify-end gap-3 pt-4 border-t">
            <button type="button" onClick={onClose} className="px-4 py-2 text-sm border rounded">Cancel</button>
            <button type="submit" disabled={loading} className="px-4 py-2 text-sm bg-primary text-white rounded flex items-center gap-2" data-testid="reschedule-submit">{loading && <Loader2 size={16} className="animate-spin" />}Save</button>
          </div>
        </form>
      </div>
    </div>
  );
}

// === ACTUAL ITEM INLINE ROW (editable qty/cost) ===
